import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Button, Tabs, List, Table} from 'antd'

import {columns} from './messagesColumns'

@inject('store') @observer
class Messages extends Component {
  render() {
    const {messages} = this.props.store.backtest
    const list = (
      <List
        dataSource={messages.results}
        renderItem={item => <List.Item>
          <p>
            <b>{item.message}</b> for <b>{item.ticker}</b>
            {item.date &&
              <span> for these dates: {item.date} {item.end_date && item.end_date !== item.date && ` - ${item.end_date}`}</span>
            }
          </p>
        </List.Item>}
      />
    )
    return(
      <Modal
        visible={this.props.visible}
        onCancel={this.props.close}
        footer={[<Button key='close' onClick={this.props.close}>Close</Button>]}
        width={600}
      >
        {messages.table
          ? <Tabs defaultActiveKey='1'>
            <Tabs.TabPane tab='Group by message' key='1'>
              {list}
            </Tabs.TabPane>
            <Tabs.TabPane tab='Table' key='2'>
              <Table
                dataSource={messages.results.slice()}
                columns={columns}
                pagination={false}
              />
            </Tabs.TabPane>
          </Tabs>
          : list
        }
      </Modal>
    )
  }
}

export default Messages
